import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

class ConnectedProtectedRoute extends Component {
  isAuth = () => {
    if (this.props.token !== null) {
      return true;
    } else {
      return false;
    }
  };

  hasRight = () => {
    /* if (this.props.rights === undefined || this.props.rights.length === 0) {
      if (
        this.props.wizard !== undefined &&
        this.props.wizard === true /* &&
        this.props.user.completeWizard === true 
      ) {
        return false;
      } else {
        return true;
      }
    } */    
    const result = this.props.user.groups.find((group) =>
      this.props.rights.includes(group.id)
    );
    if (result) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.isAuth() ? (
          this.hasRight() ? (
            <Route
              path={this.props.path}
              render={(props) =>
                React.createElement(this.props.component, {
                  ...props,
                  socket: this.props.socket,
                  groupsToLoad: this.props.groupsToLoad
                    ? this.props.groupsToLoad
                    : undefined,
                })
              }
            />
          ) : (
            <Redirect from="**" to="/tl/missing-right" />
          )
        ) : (
          <Redirect from="**" to="/login" />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.loginReducer.token,
  user: state.loginReducer.user,
});

const ProtectedRoute = connect(mapStateToProps, null)(ConnectedProtectedRoute);
export default ProtectedRoute;
